import httpService from "../../Service/httpService";

const controller = "Consultas";


export const getHorarios = async (id, fecha) => {
	const res = await httpService.get(`/${controller}/getHorarios/${id}/${fecha}`);
  return res.data;
}

export const getPaciente = async (id, tel) => {
  const res = await httpService.get(`/${controller}/getPaciente/${id}/${tel}`);
  return res.data;
}

export const getCitas = async (id, date, estatus) => {
  const res = await httpService.get(`/${controller}/getCitas/${id}/${date}/${estatus}`);
  return res.data;
}

export const getConsultorio = async (id, idMedico) => {
  const res = await httpService.get(`/${controller}/getConsultorio/${id}/${idMedico}`);
  return res.data;
}

export const saveCita = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/save`, {
		...data,
	});
	return res;
};

export const saveCancelCita = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/cancelarCita`, {
		...data,
	});
	return res;
};

export const saveUpdateCita = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/updateCita`, {
		...data,
	});
	return res;
};


// export const saveDetalleAnalisis = async (data: any) => {
// 	//   const userData = getDecodedToken();
// 	const res = await httpService.post(`/${controller}/saveDetalleAnalisis`, {
// 		...data,
// 	});
// 	return res;
// };